__turbopack_context__.v({
  "Child": "_2wHaXq_Child",
  "Child--IsActive": "_2wHaXq_Child--IsActive",
  "ChildLink": "_2wHaXq_ChildLink",
  "Children": "_2wHaXq_Children",
  "List": "_2wHaXq_List",
  "MobileDropdown": "_2wHaXq_MobileDropdown",
  "MobileDropdownIcon": "_2wHaXq_MobileDropdownIcon",
  "MobileDropdownLabel": "_2wHaXq_MobileDropdownLabel",
  "Overlay": "_2wHaXq_Overlay",
  "Root": "_2wHaXq_Root",
  "Root--IsOpen": "_2wHaXq_Root--IsOpen",
  "Section": "_2wHaXq_Section",
  "Section--HasChildren": "_2wHaXq_Section--HasChildren",
  "Section--IsActive": "_2wHaXq_Section--IsActive",
  "Section--IsExpanded": "_2wHaXq_Section--IsExpanded",
  "SectionHeader": "_2wHaXq_SectionHeader",
  "SectionLink": "_2wHaXq_SectionLink",
  "SectionLinkText": "_2wHaXq_SectionLinkText",
  "SectionWrapper": "_2wHaXq_SectionWrapper",
  "StickyList": "_2wHaXq_StickyList",
  "StickyOverlay": "_2wHaXq_StickyOverlay",
  "StickyTrigger": "_2wHaXq_StickyTrigger",
  "StickyWrapper": "_2wHaXq_StickyWrapper",
  "StickyWrapper--Open": "_2wHaXq_StickyWrapper--Open",
  "StickyWrapper--Visible": "_2wHaXq_StickyWrapper--Visible",
  "Toggle": "_2wHaXq_Toggle",
  "ToggleIcon": "_2wHaXq_ToggleIcon",
  "ToggleWrapper": "_2wHaXq_ToggleWrapper",
  "skeleton-loading": "_2wHaXq_skeleton-loading",
});
